import { render, staticRenderFns } from "./upload-logo.vue?vue&type=template&id=019df24e"
import script from "./upload-logo.vue?vue&type=script&lang=js"
export * from "./upload-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports